import styled from "styled-components"

export const ModalDescription = styled.h1`
    position: relative;
    font-size: clamp(1.3rem, 2.5vw, 1.7rem);
    color: #ffffff;
    top: 1rem;
    text-align: center;
    font-family: MontserratRegular;
`

export const ModalBody = styled.div`
    width: 100%;
    padding: 3rem 2rem 3rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow-y: auto;
    max-height: 24vw;
`

export const ModalFooter = styled.div`
    width: 100%;
    padding: 2rem 2rem 3rem 2rem;
    display: flex;
    flex-direction: row;
    justify-content: end;
`